module.exports = __webpack_public_path__ + "img/RISE.1e40e70d.svg";